<div class="loader-blow-up"></div>
<span><ng-content></ng-content></span>
